import { Box, Breadcrumbs } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { generatePath, Link } from 'react-router-dom';
import { Home } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../../rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';
import routes from '../../../routes';
import UserForm from '../../../components/UserForm';
import {
  currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite,
  getUserRolesInCurrentlySelectedSite,
} from '../../../services/auth';
import { Roles } from '../../../models/roles';
import { createFoodDonorStuff } from '../../../actions/foodDonors';
import useActiveUser from '../../../hooks/useActiveUser';

const FoodDonorMobileAddStaffBreadcrumb = () => {
  const { formatMessage } = useIntl();

  return (
    <Box boxShadow={0}>
      <Breadcrumbs aria-label="breadcrumb">
        <StyledRescuerBreadcrumb
          component={Link}
          to={generatePath(routes.mobileDashboard)}
          label={formatMessage({ id: 'breadcrumbs.home' })}
          icon={<Home style={{ color: '#fff' }} fontSize="small" />}
        />
        <StyledRescuerTextBreadcrumb
          component="a"
          href="#"
          label={formatMessage({ id: 'breadcrumbs.receiver-add-staff' })}
        />
      </Breadcrumbs>
    </Box>
  );
};

const FoodDonorMobileAddStaffContainer = () => {
  const dispatch = useDispatch();
  const activeUser = useActiveUser();
  const userRoles = getUserRolesInCurrentlySelectedSite(activeUser);
  const foodDonorRolesWithAccess = userRoles.filter(
    (role) =>
      role.role_name === Roles.DonorAdmin ||
      role.role_name === Roles.DonorStaff ||
      role.role_name === Roles.DonorLocationAdmin ||
      role.role_name === Roles.DonorLocationStaff
  );
  const foodDonorId = foodDonorRolesWithAccess[0]?.donor_location_id;

  const onUserCreate = (data) => dispatch(createFoodDonorStuff(foodDonorId, data));

  return (
    <>
      <FoodDonorMobileAddStaffBreadcrumb />

      <Box py={2} px={1}>
        <UserForm
          showUserSelector
          redirectPath={generatePath(routes.mobileDashboard)}
          submitCallback={onUserCreate}
          showIsAdminCheckbox={currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite([
            Roles.Admin,
            Roles.NationalSiteDirector,
            Roles.SiteDirector,
            Roles.DonorAdmin,
            Roles.DonorLocationAdmin,
          ])}
          isAdminCheckboxLabel="Is Donor Admin"
          showLocationFields={false}
          showEmployerFields={false}
          showQrtCheckbox={false}
        />
      </Box>
    </>
  );
};

export default FoodDonorMobileAddStaffContainer;
